export const FLAG_GETTING_BILLINGS = 'FLAG_GETTING_BILLINGS';
export const GET_BILLINGS = 'GET_BILLINGS';
export const CLEAR_BILLINGS = 'CLEAR_BILLINGS';
export const FLAG_BILLING_ACTIVITY = 'FLAG_BILLING_ACTIVITY';
export const GET_BILLING = 'GET_BILLING';
export const CLEAR_BILLING = 'CLEAR_BILLING';
